// DS Geo Visibility + Live Shipping Price — depends on the visitor's real
// country, which `localization.country` can't provide (this store's Markets
// have no web presence, so it never reflects real IP). Country is detected
// client-side via ipwho.is instead (free, no key, CORS-open — same service
// already proven working for IP geo-detection on the Accept Islam project).
//
//   1. The international shipping-weight upsell (.dsc-weightbar / .ds-weightbar)
//      — hidden by default, shown ONLY for non-Saudi visitors.
//   2. The domestic "FREE shipping" bar (drawer [data-shipbar], cart page
//      [data-shipping-bar]) — we only offer free shipping within KSA, so it
//      must be hidden for everyone else. Visible by default (no flash for the
//      majority KSA audience) and hidden once a non-Saudi visitor is confirmed;
//      stays visible if the geo lookup fails, same as before this fix existed.
//   3. The real shipping cost shown inside the upsell widget — fetched live
//      from Shopify's own cart/shipping-rate endpoints (the exact same rate
//      checkout would quote), using the visitor's real cart weight + detected
//      country. Never cached (unlike country), since it must reflect the
//      cart's current weight on every check.
//
// Country is cached in sessionStorage (1 ipwho.is call per tab session). A
// MutationObserver re-applies everything after every cart drawer re-render
// (its HTML is fully replaced on cart changes), and the cart page's own
// `cart:refresh` event (fired on every quantity change) re-triggers it there.
//
// IMPORTANT: writing the fetched price into the DOM (step 3) is itself a
// mutation inside #CartDrawer, which would immediately re-trigger the same
// MutationObserver — an infinite loop of prepare_shipping_rates.json calls
// that saturated the cart session and broke Add to Cart site-wide. The
// observer is disconnected before any of our own writes and reconnected
// right after, so it only ever reacts to the drawer's OWN re-renders.
(function () {
  var CACHE_KEY = 'dsVisitorCountryInfoV2';
  var drawer = document.getElementById('CartDrawer');
  var observer = null;
  var fetchToken = 0;

  function withObserverPaused(fn) {
    if (observer) observer.disconnect();
    fn();
    if (observer && drawer) observer.observe(drawer, { childList: true, subtree: true });
  }

  function applyVisibility(isNonSaudi) {
    withObserverPaused(function () {
      document.querySelectorAll('[data-ds-weightbar]').forEach(function (el) {
        el.style.display = isNonSaudi ? 'flex' : 'none';
      });
      document.querySelectorAll('[data-shipbar], [data-shipping-bar]').forEach(function (el) {
        el.style.display = isNonSaudi ? 'none' : '';
      });
    });
  }

  function applyShippingPrice(rate) {
    withObserverPaused(function () {
      document.querySelectorAll('[data-ds-shipping-price]').forEach(function (wrap) {
        var valueEl = wrap.querySelector('[data-ds-shipping-price-value]');
        if (rate && valueEl) {
          valueEl.textContent = parseFloat(rate.price).toFixed(2) + ' ' + rate.currency;
          wrap.hidden = false;
        } else {
          wrap.hidden = true;
        }
      });
    });
  }

  function pollShippingRates(token, attempt) {
    attempt = attempt || 0;
    return fetch('/cart/async_shipping_rates.json', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        if (token !== fetchToken) return null; // a newer refresh superseded this one
        var rates = data && data.shipping_rates;
        if (rates && rates.length) return rates[0];
        if (attempt < 6) {
          return new Promise(function (resolve) {
            setTimeout(function () { resolve(pollShippingRates(token, attempt + 1)); }, 500);
          });
        }
        return null;
      });
  }

  function fetchLiveShippingPrice(countryName, zip) {
    var token = ++fetchToken;
    fetch('/cart/prepare_shipping_rates.json', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      // zip is required by Shopify's rate validation for many countries
      // ("Enter a postcode" 422 otherwise) — ipwho.is's approximate postal
      // code for the visitor's detected city satisfies this; it doesn't need
      // to be their exact address since these are country/weight-based zones.
      body: JSON.stringify({ shipping_address: { country: countryName, zip: zip || '', province: '' } })
    })
      .then(function () { return pollShippingRates(token); })
      .then(function (rate) { if (token === fetchToken) applyShippingPrice(rate); })
      .catch(function () { if (token === fetchToken) applyShippingPrice(null); });
  }

  var refreshTimer = null;
  function refresh() {
    clearTimeout(refreshTimer);
    refreshTimer = setTimeout(runRefresh, 150);
  }

  function runRefresh() {
    var cached = sessionStorage.getItem(CACHE_KEY);
    if (cached !== null) {
      var info = null;
      if (cached) {
        try { info = JSON.parse(cached); } catch (e) { info = null; }
      }
      applyVisibility(!!info);
      // fetchLiveShippingPrice() DISABLED (2026-08-25) — /cart/prepare_shipping_rates.json
      // appears to place a temporary hold on inventory during rate calculation; on this
      // store's low-stock clearance items that hold was enough to make genuinely
      // in-stock products briefly report as sold out to OTHER real shoppers hitting
      // /cart/add.js at the same time. Not safe to call from an unthrottled background
      // widget. Re-enable only after confirming with Shopify/support that this endpoint
      // does not reserve inventory, or after moving it behind an explicit user action
      // (not an automatic background check) with heavy rate-limiting.
      applyShippingPrice(null);
      return;
    }
    fetch('https://ipwho.is/')
      .then(function (r) { return r.json(); })
      .then(function (data) {
        var isNonSaudi = !!data && data.country_code && data.country_code !== 'SA';
        var info = isNonSaudi ? { code: data.country_code, name: data.country, zip: data.postal } : null;
        sessionStorage.setItem(CACHE_KEY, info ? JSON.stringify(info) : '');
        applyVisibility(isNonSaudi);
        applyShippingPrice(null);
      })
      .catch(function () {
        sessionStorage.setItem(CACHE_KEY, '');
        applyVisibility(false);
      });
  }

  document.addEventListener('DOMContentLoaded', refresh);
  document.addEventListener('cart:refresh', refresh);

  if (drawer) {
    observer = new MutationObserver(refresh);
    observer.observe(drawer, { childList: true, subtree: true });
  }
})();
